import type { AalExportPayload, AalView } from "../aalV2";
import { useAalExport } from "../aalV2";

export type DownloadAALWithdrawalsPayload = AalExportPayload & {
  agent_id?: string;
  agent_role_id?: string;
  username?: string;
  payment_gateway?: string;
  payment_method?: string;
  status?: string;
  subregion?: string;
};

export const useDownloadAALWithdrawalsTable = (view: AalView) =>
  useAalExport("withdrawals", view);
